import './styles.scss';
import Application from './application';

(function () {
  Application();
})();